import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { activityApi } from './api/activity.api';
import type { NotificationsResponse } from './types';

export const activityKeys = { notifications: ['notifications'] as const, project: (id: string) => ['activity', id] as const };

export function useNotifications() {
  return useQuery({ queryKey: activityKeys.notifications, queryFn: () => activityApi.notifications(), refetchInterval: 30_000 });
}

export function useMarkNotificationsSeen() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (until?: string) => activityApi.seen(until),
    // the badge and the list clear at once; the next poll brings only what arrived later
    onMutate: () => client.setQueryData<NotificationsResponse>(activityKeys.notifications, { items: [], unread: 0 }),
    onSettled: () => client.invalidateQueries({ queryKey: activityKeys.notifications })
  });
}

export function useProjectActivity(projectId: string) {
  return useQuery({ queryKey: activityKeys.project(projectId), queryFn: () => activityApi.project(projectId), enabled: !!projectId });
}
